import { render, staticRenderFns } from "./GeneralEmailsComponent.vue?vue&type=template&id=dbf02978&"
import script from "./GeneralEmailsComponent.vue?vue&type=script&lang=js&"
export * from "./GeneralEmailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports